import React from 'react';

const FormandosIco = () => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 540.4 490">
      <path class="st0" d="M374.5,105c0,58-47,105-105,105s-105-47-105-105s47-105,105-105S374.5,47,374.5,105" />
      <path class="st0" d="M467.8,431.7v35c0,12.9-10.4,23.3-23.3,23.3h-350c-12.9,0-23.3-10.4-23.3-23.3v-35c0-20.7,3.2-40.7,9.1-59.5
	c1.7-5.6,3.7-11,5.9-16.3c13-31.3,33.7-58.6,59.8-79.4c8.1-6.4,16.6-12.2,25.6-17.3c28.9-16.4,62.3-25.8,97.8-25.8
	c49.3,0,94.5,18,129.2,47.8c27.8,23.9,48.8,55.2,60.1,91C464.7,391,467.8,411,467.8,431.7z"/>
      <path class="st0" d="M374.5,105c0,58-47,105-105,105s-105-47-105-105s47-105,105-105S374.5,47,374.5,105" />
      <path class="st0" d="M151.7,163.4c0,29-23.5,52.5-52.5,52.5s-52.5-23.5-52.5-52.5s23.5-52.5,52.5-52.5S151.7,134.4,151.7,163.4" />
      <path class="st0" d="M61.7,355.9h-50c-6.4,0-11.7-5.2-11.7-11.7v-17.5c0-10.4,1.6-20.3,4.5-29.7c6-19.1,17.6-35.7,32.9-47.9
	c16.9-13.5,38.4-21.6,61.7-21.6c20.5,0,39.6,6.2,55.5,16.9c2.8,1.9,2.7,6.1-0.2,7.9c-7.4,4.6-14.6,9.6-21.4,15
	c-27.8,22.2-50.2,50.9-64.6,84C67.3,354.2,64.6,355.9,61.7,355.9z"/>
      <path class="st0" d="M151.7,163.4c0,29-23.5,52.5-52.5,52.5s-52.5-23.5-52.5-52.5s23.5-52.5,52.5-52.5S151.7,134.4,151.7,163.4" />
      <path class="st0" d="M61.7,355.9h-50c-6.4,0-11.7-5.2-11.7-11.7v-17.5c0-10.4,1.6-20.3,4.5-29.7c6-19.1,17.6-35.7,32.9-47.9
	c16.9-13.5,38.4-21.6,61.7-21.6c20.5,0,39.6,6.2,55.5,16.9c2.8,1.9,2.7,6.1-0.2,7.9c-7.4,4.6-14.6,9.6-21.4,15
	c-27.8,22.2-50.2,50.9-64.6,84C67.3,354.2,64.6,355.9,61.7,355.9z"/>
      <path class="st0" d="M388.7,163.4c0-29,23.5-52.5,52.5-52.5s52.5,23.5,52.5,52.5s-23.5,52.5-52.5,52.5S388.7,192.4,388.7,163.4" />
      <path class="st0" d="M478.7,355.9h50c6.4,0,11.7-5.2,11.7-11.7v-17.5c0-10.4-1.6-20.3-4.5-29.7c-6-19.1-17.6-35.7-32.9-47.9
	c-16.9-13.5-38.4-21.6-61.7-21.6c-20.5,0-39.6,6.2-55.5,16.9c-2.8,1.9-2.7,6.1,0.2,7.9c7.4,4.6,14.6,9.6,21.4,15
	c27.8,22.2,50.2,50.9,64.6,84C473.1,354.2,475.8,355.9,478.7,355.9z"/>
    </svg>
  )
}

export default FormandosIco;